module.exports = __webpack_public_path__ + "img/Rectangle-13.4876357b.png";